export default __webpack_public_path__ + "static/media/camcorder.514a1d7e.svg";